/**
 * IntroBlockArrow
 */
import clsx from 'clsx';
import React from 'react';
/** An intro block with background. */
var IntroBlockArrow = function (_a) {
    var className = _a.className;
    return (React.createElement("div", { "data-cid": "IntroBlockArrow", className: clsx(className, 'relative mx-auto max-w-site intro-block-arrow') }));
};
export default IntroBlockArrow;
